import React from 'react';
import { computationDecimalScale } from '../../../../common/helper';
import FormsyInputField from '../../../elements/FormsyInputField';
import FormsySelect from '../../../elements/FormsySelect';

const BasicDetails = ({
    computationDetails,
    allfieldsReadonly,
    isRegeneratedFieldActive,
    financierId,
    allOptions,
    computationDetailsForm,
    handlePatternFormatChange,
    handleInputChange,
    handleMakeChange,
    handleSelectChange,
}) => {
    return <div className="row">
        {computationDetailsForm.map((field) => (
            ["text", "number-format"].includes(field.type) ? (
                <fieldset className="form-filed col-md-6 " style={{ display: ((`${field.name}` === "other_vehicle_type" && (!computationDetails?.["vehicle_type"] || computationDetails?.["vehicle_type"] !== 6))) ? "none" : "block" }}>
                    <FormsyInputField
                        id={field.id}
                        name={field.name}
                        type={field.type}
                        value={computationDetails && computationDetails[field.name]}
                        placeholder=" "
                        {...(field.type === "number-format") ? {
                            thousandsGroupStyle: "thousand",
                            thousandSeparator: ',',
                            decimalSeparator: '.'
                        } : {}}
                        label={field.label}
                        onChange={
                            field.type === "number-format"
                                ? (data) => handlePatternFormatChange(data, field.name)
                                : handleInputChange
                        }
                        format={field.ApplyNumberformat ? field.format : ""}
                        validations={field.validations}
                        validationError={
                            computationDetails?.[field.name] ? field.validationError : ""
                        }
                        required={field.required}
                        readOnly={field.readOnly || allfieldsReadonly || isRegeneratedFieldActive(field?.name)}
                        decimalScale={computationDecimalScale(financierId)}
                    />
                </fieldset>
            ) :
                field.type === "dropdown" ? (
                    <fieldset className="single-select col-md-6">
                        <FormsySelect
                            name={field.name}
                            id={field.id}
                            inputProps={{
                                options: allOptions?.[field?.optionsKey],
                                placeholder: field.label,
                                className: "react-select",
                                classNamePrefix: "react-select",
                                value: allOptions?.[field?.optionsKey]?.filter(({ value }) => value?.toString() === computationDetails?.[field?.name]?.toString()),
                                isDisabled: field.readOnly || allfieldsReadonly || isRegeneratedFieldActive(field?.name)
                            }}
                            required={field.required}
                            value={computationDetails && computationDetails[field?.name]}
                            onChange={(data) => ["make_id", "model_id", "vehicle_usage", "vehicle_type"].includes(field.name) ? handleMakeChange(field.name, data) : handleSelectChange(data, field.name)}
                        />
                    </fieldset>
                ) : null
        ))}
    </div>;
};


export default BasicDetails;
